import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseFeedbackReasonsResponse } from './schemas'

export type ResponseFeedbackState = {
  feedbackReasonsData: ResponseFeedbackReasonsResponse
  feedbackReasonsLoading: boolean
  feedbackReasonsError: boolean
}

const initialState: ResponseFeedbackState = {
  feedbackReasonsData: {
    negative_reasons: [],
  },
  feedbackReasonsLoading: false,
  feedbackReasonsError: false,
}

/**
 * Response Feedback Slice
 * Holds feedback reasons data to be displayed to the user.
 */
export const responseFeedbackSlice = createSlice({
  name: 'responseFeedbackState',
  initialState,
  reducers: {
    // ============== Listener Actions ============== >
    fetchFeedbackReasons: (_state) => {
      // Handled by the listener middleware
    },

    // ============== Slice Actions ============== >
    nullifyData: () => initialState,

    // Set loading state
    setFeedbackReasonsLoading: (state, action: PayloadAction<boolean>) => {
      state.feedbackReasonsLoading = action.payload
    },

    // Set error state
    setFeedbackReasonsError: (state, action: PayloadAction<boolean>) => {
      state.feedbackReasonsError = action.payload
    },

    // Set feedback reasons data
    setFeedbackReasonsData: (state, action: PayloadAction<ResponseFeedbackReasonsResponse>) => {
      state.feedbackReasonsData = action.payload
    },
  },
})

// Actions
export const ResponseFeedbackActions = responseFeedbackSlice.actions

export default responseFeedbackSlice.reducer
